import React from 'react';
import _ from 'lodash';

import {connect} from "react-redux";
import {withRouter} from "react-router";

import { getPortfolioCategory } from '../../../../../../../../components/CustomersDataProvider/utils'
import { GROUP_ACTION_DEPOT } from '../../../../../../../../components/Charts/InstrumentsAllocationTable/constants'
import {isTradingEnabled} from "../../../../../../../../components/TradingStore/utils";
import WarningTooltip from "../../../../../../../../components/WarningTooltip";


import {
  REPORT_TYPES
} from "../../../../../../../DashboardSettings/components/CustomersList/components/ReportType/constants";
import {getSharedSettingsWarning, isExpanded, wholeDepotOrderHandler} from '../../../../../../utils';
import {getCustodianData} from "../../../../../../../RiskProfiling/utils";
import {displayErrorSnackBar} from "../../../../../../../../components/SnackbarProvider/actions";
import UnrealizedProfitAndLossItem from "../UnrealizedProfitAndLossItem";
import Grid from "@material-ui/core/Grid";
import {
  getAuthSelector,
  getInvestmentPlatformSelector,
  getSharedSettingsSelector
} from "../../../../../../../../utils/redaxSelectors";
import ChartSectionBordered, {
  ChartSectionPortfolioName
} from "../../../../../../components_v2/ChartSectionBordered/ChartSectionBordered";
import InstrumentsAllocationTable from "../../../../../../../../components/ChartsV2/InstrumentsAllocationTable";
import ClearingAccountTable from "../../../../../../../../components/ChartsV2/ClearingAccountTable";
import {
  getColorByValue,
  getDepotContainerId,
  withEuroOrDash,
  withPercentOrDash
} from "../../../../../../../../utils/utils";
import DashboardChartSection from '../../../DashboardChartSection';
import useStyles from './styles';
import VirtualDepotDeleteBtn
  from "../../../../../../components_v2/ActionButtons/VirtualdepotActions/VirtualDepotDeleteButton";
import VirtualDepotEditButton
  from "../../../../../../components_v2/ActionButtons/VirtualdepotActions/VirtualDepotEditButton";
import VirtualDepotOrderButton
  from "../../../../../../components_v2/ActionButtons/VirtualdepotActions/VirtualDepotOrderButton";


const mapStateToProps = (state) => ({
  auth: getAuthSelector(state),
  investmentPlatform: getInvestmentPlatformSelector(state),
  sharedSettings: getSharedSettingsSelector(state)
});

export const DepotSummaryNavigation = connect(mapStateToProps)((props) => {
  const {
    depot,
    sharedSettings,
    reportType,
    showColumnCallback,
  } = props;

  const classes = useStyles();

  const headerData = (() => {
    const columns = [{
      title: 'Wert',
      value: withEuroOrDash(depot.market_value),
      key: 'MarketValueCell',
      className: 'euroValue'
    }];

    if (reportType != REPORT_TYPES.DEPOT_STATUS.value) {
      columns.push({
        title: 'Anfangsbestand',
        value: withEuroOrDash(depot.profit_value_start),
        key: 'BeginningValueCell',
        className: 'euroValue'
      }, {
        title: 'Kapitaleinsatz',
        value: withEuroOrDash(depot.invested_amount),
        key: 'InvestedAmountCell',
        className: 'euroValue'
      }, {
        title: 'GuV (€)',
        value: (<>{depot.profit_loss_eur > 0 ? '+' : ''}{withEuroOrDash(depot.profit_loss_eur)}</>),
        color: getColorByValue(depot.profit_loss_eur),
        key: 'ReturnCellEuro'
      }, {
        title: 'GuV (%)',
        value: (<>{depot.profit_loss_perc > 0 ? '+' : ''}{withPercentOrDash(depot.profit_loss_perc, true)}</>),
        color: getColorByValue(depot.profit_loss_perc),
        key: 'ReturnCellPercentage'
      }, {
        title: 'GuV p.a. (%)',
        value: (<>{depot.profit_loss_percentage_pa > 0 ? '+' : ''}{withPercentOrDash(depot.profit_loss_percentage_pa, true)}</>),
        color: getColorByValue(depot.profit_loss_percentage_pa),
        warning: getSharedSettingsWarning(depot.portfolio_pa_warning, sharedSettings.data),
        key: 'ReturnPACell'
      });
    }

    return columns;

  })();

  const columnXsWidth = headerData.length > 1 ? 6 : 12;

  return (
    <Grid container spacing={2} className={classes.headerValuesContainer}>
      {headerData.map((column) => {

        if (showColumnCallback && !showColumnCallback(column.key)) {
          return null;
        }

        return (
          <Grid item xs={columnXsWidth} sm={"auto"} className={column.className}>
            <span className="title">{column.title}</span>
            <span className="value" style={column.color ? {color: column.color} : {}}>
              {!!column.warning
                ? <>- <WarningTooltip title={column.warning}/></>
                : column.value
              }
            </span>
          </Grid>
        )
      })}
    </Grid>
  )
});

const InstrumentListItem = (props) => {
  const classes = useStyles();

  const {
    portfolio,
    virtualInstrumentLink,
    expandedItems,
    onExpanded,
    isCustomerApp,
    onAddTradingOption,
    onAddPortfolioTradingOption,
    tradings,
    banksMapping,
    tradeTransactions,
    reportType,
    auth,
    isVirtual,
    triggerPortfolioDeleting,
    refresh,
    customerData,
    canTradePortfolios,
    instrumentsGroupBy,
    withTransactionSaldo,
    withCompletelySoldAssets,
    unrealizedProfitAndLossData,
    footerText,
    showAssetsOverview,
    dataProvider,
    match: {params: {customer_id}}
  } = props;

  const isExpandedDepotSection = isExpanded(expandedItems, `depots.${portfolio.id}`);
  const isDataExist = !portfolio.is_historical || ((!portfolio.is_empty || !_.isEmpty(portfolio.components)) && portfolio.hasOwnProperty('value'));

  const dataSource = portfolio.components || [];

  let tradingEnabled = isTradingEnabled();
  const { isModelportfolio, isDisabled, bankCode } = getPortfolioCategory(portfolio);
  const isBankAvailable = !portfolio.is_manual && banksMapping && banksMapping.hasOwnProperty(bankCode);
  const isTradingAvailable = tradingEnabled && isBankAvailable;
  const isPtfTradingDisabled = isDisabled || !isBankAvailable;

  const isPtfTradingEnabled = tradingEnabled && !isPtfTradingDisabled;

  const [custodiansInstrumentsData, setCustodiansInstrumentsData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [wholeDepotTradingAction, setWholeDepotTradingAction] = React.useState("default");

  React.useEffect(() => {
    if(isPtfTradingEnabled){
      setLoading(true);
      getCustodianData(dataSource, [bankCode], withCompletelySoldAssets).then(res => {
        if(res && !_.isEmpty(res[bankCode])){
          setCustodiansInstrumentsData(res[bankCode]);
        }
      }).catch(error => {
        props.dispatch(displayErrorSnackBar(error.detail || error.message || error))
      }).finally(() => setLoading(false));
    }
  }, [isPtfTradingEnabled]);

  const handleWholeDepotOrderChange = (event) => {
    const tradingType = event.target.value;
    if (tradings && onAddTradingOption && tradingType !== 'default') {
      (tradings.instruments || []).forEach(item => onAddTradingOption(portfolio, item.data, 'default'))
    }
    setWholeDepotTradingAction(tradingType);
    wholeDepotOrderHandler(portfolio, onAddTradingOption, tradingType, custodiansInstrumentsData);
  };

  const handleExpandedDepotsChange = (expanded) => {
    onExpanded(['instrumentsTab', 'depots', portfolio.id], expanded);
  };

  const onExpandedClearingAccountsChange = (expanded) => {
    onExpanded(['instrumentsTab', 'clearingAccounts', portfolio.id], expanded);
  };

  const onExpandedSecuritiesChange = (expanded) => {
    onExpanded(['instrumentsTab', 'securities', portfolio.id], expanded);
  };

  const onExpandedBaseFondsChange = (expanded) => {
    onExpanded(['instrumentsTab', 'baseFonds', portfolio.id], expanded);
  };

  const renderAssetTable = (data, subItemsField='instrumentsSubItems', isTradingDisabled=false) => {
    const onExpandedSubItems = (elementId, expanded) => {
      onExpanded(['instrumentsTab', subItemsField, portfolio.id, elementId], expanded);
    };

    return <InstrumentsAllocationTable
      resource={props.resource}
      data={data || assetTableData}
      virtualInstrumentLink={virtualInstrumentLink}
      expanded={isExpandedDepotSection}
      expandedSubItems={_.get(expandedItems, [subItemsField, portfolio.id])}
      onExpandedSubItems={onExpandedSubItems}
      isCustomerApp={isCustomerApp}
      isVirtualOrderEnabled={props.isVirtualOrderEnabled}
      onAddTradingOption={handleAddTradingOption}
      handleAddPortfolioTradingOption={handleAddPortfolioTradingOption}
      handleWholeDepotOrderChange={handleWholeDepotOrderChange}
      wholeDepotTradingAction={wholeDepotTradingAction}
      tradings={tradings}
      tradeTransactions={tradeTransactions}
      reportType={reportType}
      isVirtual={isVirtual}
      refresh={refresh}
      deletePortfolio={triggerPortfolioDeleting}
      isModelportfolio={isModelportfolio}
      isPassive={!!portfolio.is_passive}
      isPtfTradingDisabled={isPtfTradingDisabled || isTradingDisabled}
      isTradingAvailable={isTradingAvailable}
      canTradePortfolios={canTradePortfolios}
      custodiansInstrumentsData={custodiansInstrumentsData}
      loading={loading}
      banksMapping={banksMapping}
      bankCode={bankCode}
      customerData={customerData}
      instrumentsGroupBy={instrumentsGroupBy}
      showCell={props.showCell}
      user={auth && auth.user}
      footerText={footerText}
      withCompletelySoldAssets={withCompletelySoldAssets}
    />
  };

  const renderData = () => {
    return (
      <>
        {isDataExist && isExpandedDepotSection && (
          <>
            {instrumentsGroupBy == GROUP_ACTION_DEPOT
              ? showAssetsOverview ? (
                <>
                  <DashboardChartSection
                    title={"Wertpapiere"}
                    content={renderAssetTable()}
                    expanded={isExpanded(expandedItems, `securities.${portfolio.id}`)}
                    onExpanded={onExpandedSecuritiesChange}
                    customClasses={{
                      container: classes.tableContainer,
                      contentContainer: classes.tableSection,
                      headerContainer: classes.headerContainer,
                      header: classes.tableSectionHeader
                    }}
                  />
                  {!_.isEmpty(baseFondsData.components) && (
                    <DashboardChartSection
                      title={"Basisfonds"}
                      expanded={isExpanded(expandedItems, `baseFonds.${portfolio.id}`)}
                      onExpanded={onExpandedBaseFondsChange}
                      content={renderAssetTable(baseFondsData, 'baseFondsSubItems', true)}
                      customClasses={{
                        container: classes.tableContainer,
                        contentContainer: classes.tableSection,
                        headerContainer: classes.headerContainer,
                        header: classes.tableSectionHeader
                      }}
                    />
                  )}
                </>
              ) : null
              : <div className={classes.tableSection}>{renderAssetTable()}</div>
            }
          </>
        )}
        {isExpandedDepotSection && !_.isEmpty(portfolio.clearing_account) && (
          <DashboardChartSection
            title={"Verrechnungskonto"}
            expanded={isExpanded(expandedItems, `clearingAccounts.${portfolio.id}`)}
            onExpanded={onExpandedClearingAccountsChange}
            content={<ClearingAccountTable data={portfolio.clearing_account}/>}
            customClasses={{
              container: classes.tableContainer,
              contentContainer: classes.tableSection,
              headerContainer: classes.headerContainer,
              header: classes.tableSectionHeader
            }}
          />
        )}
        {isExpandedDepotSection && withTransactionSaldo && renderUnrealizedProfitAndLossItem(portfolio.id)}
      </>
    );
  };

  const handleAddTradingOption = (instrument, tradingType, deletePaymentPlanTradingType) => {
    if (onAddTradingOption) {
      onAddTradingOption(portfolio, instrument, tradingType, deletePaymentPlanTradingType)
    }
  }

  const handleAddPortfolioTradingOption = (event, deletePaymentPlanTradingType) => {
    if (onAddPortfolioTradingOption) {
      onAddPortfolioTradingOption(portfolio, event.target.value, deletePaymentPlanTradingType)
    }
  }

  const renderUnrealizedProfitAndLossItem = (portfolio_id) => {
    const expanded = isExpanded(expandedItems, `transactionsSaldo.${portfolio_id}`);
    const onExpandedItemsChange = (expanded) => onExpanded(['instrumentsTab', 'transactionsSaldo', portfolio.id], expanded);
    const portfolioTransactData = _.get(unrealizedProfitAndLossData, `portfolios_transactions_data.${portfolio_id}`);

    return (
      <>
      {portfolioTransactData &&
        <UnrealizedProfitAndLossItem
          expanded={expanded}
          onExpandedItemsChange={onExpandedItemsChange}
          portfolioTransactData={portfolioTransactData}
        />
      }
      </>
    )
  }

  const sideNavigationContent = (
    <>
      {!portfolio.not_connected && !portfolio.is_group && (
        <DepotSummaryNavigation depot={portfolio} reportType={reportType} showColumnCallback={props.showCell}/>
      )}
    </>
  );

  const [baseFondsData, assetTableData] = React.useMemo(() => {
    const baseFond = _.get(portfolio, 'model_portfolio_data.base_fond');
    let baseFondsComponents = [], components = [];
    if (baseFond) {
      dataSource.forEach(i => {
        if(i.is_profit_loss){
          const baseFondSoldItems = [], soldItems = [];
          (i.sub_components || []).forEach(sub_i => {
            if(sub_i.isin === baseFond){
              baseFondSoldItems.push(sub_i);
            } else {
              soldItems.push(sub_i);
            }
          });
          if(!_.isEmpty(baseFondSoldItems)){
            baseFondsComponents.push({...i, sub_components: baseFondSoldItems});

            // keep remaining sold assets in main line if any
            if(!_.isEmpty(soldItems)){
              components.push({...i, sub_components: soldItems});
            }
          }
        } else if(i.isin === baseFond){
          baseFondsComponents.push(i);
        } else {
          components.push(i)
        }
      });
    } else {
      components = dataSource
    }

    return [{...portfolio, components: baseFondsComponents}, {...portfolio, components: components}]
  }, [portfolio]);


  return (
    <Grid item xs={12}>
      <ChartSectionBordered
        dataId={`instrument-table-${portfolio.id}`}
        title={(
          <>
            <ChartSectionPortfolioName portfolio={portfolio} />
            {portfolio.is_manual && (
              <div style={{paddingLeft: '1em', minWidth: 'fit-content'}}>
                <Grid container spacing={1} alignItems={"center"}>
                  <Grid item>
                    <VirtualDepotEditButton portfolio={portfolio} onUpdate={refresh} dataProvider={dataProvider} />
                  </Grid>
                  <Grid item>
                    <VirtualDepotOrderButton portfolio={portfolio} refresh={refresh} dataProvider={dataProvider} />
                  </Grid>
                  <Grid item>
                    <VirtualDepotDeleteBtn
                      customerId={customer_id}
                      portfolioId={portfolio.id}
                      assetContainerId={getDepotContainerId(portfolio)}
                      portfolioName={portfolio.name}
                      onDelete={refresh}
                      dataProvider={dataProvider}
                    />
                  </Grid>
                </Grid>
              </div>
            )}
          </>
        )}
        titleControl={sideNavigationContent}
        showTitleControlFolded
        expanded={isExpandedDepotSection}
        isPortfolioSection
        skipContentPadding
        borderLeftColor={portfolio.color}
        onExpanded={handleExpandedDepotsChange}
        content={renderData()}
      />
    </Grid>
  )
}

export default connect(mapStateToProps)(withRouter(InstrumentListItem));
